export default "__VITE_ASSET__eFQZFArPMr5GabmmbToYsw__";